import React, { useEffect, useRef, useState,useCallback} from 'react';
import Dropdown from 'react-dropdown'
import accounts from "accounts/Accounts.js";
import ConditionedComponent from 'components/ConditionedComponent.js';
import { connect } from "react-redux";
import {MASTER, SLAVE} from 'constants/clock-types.js';
import {SYNCED, WAITING} from 'constants/connection-status-types.js';
import ethereum from 'decentralized/ethereum.js';
import {sleep} from "utils/sleep.js"


const getAsks = async (setAsking, ownUserId, cancelRef) => {
    console.log('getClockASks for userId=', ownUserId);
    fetch('/getClockAsks/' + ownUserId, {
        method: 'GET',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }
    })
        .then(async resp => {
            let json = await resp.json();
            if (json !== 0 && json !== "0") {
                setAsking(json);
            } else {
                if (cancelRef.current) {
                    return;
                }
                await sleep(1000);
                getAsks(setAsking, ownUserId, cancelRef);
            }
        });
};

const ClockOptions = (props) => {
    let [asking, setAsking] = useState(undefined);
    let [askUserName, setAskUserName] = useState(undefined);
    let cancelRef = useRef(false);

    useEffect(() => {
        if (!asking) {
            return;
        }
        ethereum.users.getUserName(asking).then(
            setAskUserName);
    }, [asking, setAskUserName]);

    useEffect(() => {
        accounts.getAccount().then(
            userId=>
            getAsks(setAsking, userId, cancelRef));

        return () => cancelRef.current = true;
    }, []);

    useEffect(() => {
        props.sequencerEngine.clockSync.startListening();
    }, []);

    const onClickUser = useCallback(async (user) => {
        if (props.connectionStatus === SYNCED) {
            return;
        }
        let userId = await ethereum.users.getUserId(user);

        
        props.sequencerEngine.clockSync.askToConnect(userId);
    }, [props.connectionStatus]);

    const connectWithAsk = useCallback(() => {
        if (asking) {
            props.sequencerEngine.clockSync.setClockType(SLAVE);
            props.sequencerEngine.clockSync.syncToUser(asking);
        }
    }, [asking]);

    const onSelectClockType = (o) => {
        props.sequencerEngine.clockSync.setClockType(o.value);
    };

    const getClassName = useCallback((userName) => {
         let className = userName === props.connectedUserName ?
            "available-user selected" : "available-user";
        return className;
    }, [props.connectedUserName, asking]);

    if (props.connectionStatus === SYNCED) {
        return (
            <div className="clock-type-container">
                  <div className="sub-header">Clock Syncing</div>
              Connected with <span className="clock-user">{props.connectedUserName}</span>
            </div>);
    }
    if (props.connectionStatus === WAITING) {
        return (
            <div className="clock-type-container">
              <div className="sub-header">Clock Syncing</div>
              Waiting to connect...
            </div>);
    }
    if (askUserName) {
        return (<div className="clock-type-container">
                  <div className="sub-header">Clock Syncing</div>
                  <div className="ask-text">
                    <span className="clock-user">{askUserName}</span> wants to sync clocks with you.
                  </div>
                  <div className="ask-buttons">
                    <div
                      onClick={connectWithAsk}
                      className="ok-btn">Connect</div>
                    <div className="cancel-btn">Cancel</div>
                  </div>
                </div>);
    }
    return (
        <div className="clock-type-container">
          <div className="sub-header">Clock Syncing</div>
          <div className="available-users">
            People available to connect:
            {props.availableUsers.map(
                user =>
                <div
                  onClick={() => onClickUser(user)}
                  className={getClassName(user)}>{user}
                  <ConditionedComponent condition={props.connectionStatus === SYNCED}>
                    <div className="user-status">CONNECTED</div>
                  </ConditionedComponent>
                </div>)}
          </div>
        </div>
    );

}

const CLOCK_OPTIONS = [
    {value: 'NONE', label: 'None'},
    {value: MASTER, label: 'Master'},
    {value: SLAVE, label: 'Slave'},
];

function getClockOption(val) {
    return CLOCK_OPTIONS.filter(
        opt => opt.value === val)[0];
}

const mapStateToProps = state => {
    return {
        clockType: state.sequencer.clockType,
        availableUsers: state.sequencer.clockType === MASTER ? [] : state.clock.availableUsers,
        connectedUserName: state.clock.connectedUserName,
        connectionStatus: state.clock.connectionStatus,
    };
};

const mapDispatchToProps = dispatch => {
    return {
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(ClockOptions);
